import React from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Box from '@material-ui/core/Box';

import TicketsManagerTabs from "../../components/TicketsManagerTabs";
import Ticket from "../../components/Ticket";
import TicketAdvancedLayout from "../../components/TicketAdvancedLayout";
import { QueueSelectedProvider } from "../../context/QueuesSelected/QueuesSelectedContext";

const useStyles = makeStyles(() => ({
    content: {
        overflow: "auto",
        minHeight: 0,
        height: "100%",
    }
}));

const TicketAdvanced = () => {
    const classes = useStyles();
    const { ticketId } = useParams();
    const hasSelectedTicket = ticketId && ticketId !== "undefined";

    return (
        <QueueSelectedProvider>
            <TicketAdvancedLayout>
                <Box className={classes.content}>
                    {hasSelectedTicket ? <Ticket /> : <TicketsManagerTabs />}
                </Box>
            </TicketAdvancedLayout>
        </QueueSelectedProvider>
    );
};

export default TicketAdvanced;
